import React from 'react';
import { connect } from 'react-redux';
import ToolTip from '@ertelecom/ui-react/components/tooltip';
import crossIcon from '../../../assets/img/cross.svg';
import { GA } from '../../../api/channels';

import {
    Channel,
    ChannelLink,
    ToolTipInner,
    ToolTipClose,
    TooltipTitle,
    TooltipSubtitle,
    TooltipText,
} from './styled';

class ChannelItem extends React.Component {
    state = {
        isTooltipActive: false,
    }

    channelRef = React.createRef();

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('click', this.onClickOutside);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
        document.addEventListener('click', this.onClickOutside);
    }

    onClickOutside = ({ srcElement }) => {
        if (this.state.isTooltipActive === true && this.channelRef.current !== srcElement) {
            this.setState({ isTooltipActive: false });
        }
    }

    onScroll = () => {
        if (this.state.isTooltipActive === false) {
 return;
}

        if (this.timeout) {
            clearTimeout(this.timeout);
        } else {
            this.setState({ isTooltipActive: false });
        }

        this.timeout = setTimeout(() => {
            this.timeout = undefined;
        }, 100);
    }

    onClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState({ isTooltipActive: true });

        GA({
            action: 'Click_сhannel',
            label: this.props.item.title,
        });
    }

    onClickClose = (e) => {
        e.preventDefault();
        this.setState({ isTooltipActive: false });
    }

    render() {
        const { item, city } = this.props;
        const { isTooltipActive } = this.state;
        const currRef = this.channelRef?.current;

        return (
            <Channel>
                <ChannelLink ref={this.channelRef} href={`https://${city.domain}.dom.ru/domru-tv/channel/${item.chid}`} onClick={this.onClick}>{item.title}</ChannelLink>
                {currRef && <ToolTip group={item.title} parent={currRef} active={isTooltipActive} position='top' arrow='center' useHover={false} tooltipTimeout={0}>
                    <ToolTipInner>
                        <ToolTipClose style={{ backgroundImage: `url(${crossIcon})` }} onClick={this.onClickClose} />
                        <TooltipTitle href={`https://${city.domain}.dom.ru/domru-tv/channel/${item.chid}`} target='_blank' rel='noopener noreferrer nofollow'>{item.title}</TooltipTitle>
                        <TooltipSubtitle>{item.button}</TooltipSubtitle>
                        <TooltipText>{item.description}</TooltipText>
                    </ToolTipInner>
                </ToolTip>}
            </Channel>
        );
    }
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity,
});

export default connect(
    mapStateToProps,
)(ChannelItem);
